import Clean1 from '../../assets/images/Photo/clean_1.webp'
import Clean2 from '../../assets/images/Photo/clean_2.webp'
import Clean3 from '../../assets/images/Photo/clean_3.jpg'
import Clean4 from '../../assets/images/Photo/clean_4.jpg'

class Activity {
    constructor(image, link, recolected, titleEs, locationEs, dateEs, descriptionEs, titleEn, locationEn, dateEn, descriptionEn) {
        this.es = {
            title: titleEs,
            location: locationEs,
            date: dateEs,
            description: descriptionEs
        };
        this.en = {
            title: titleEn,
            location: locationEn,
            date: dateEn,
            description: descriptionEn
        };

        this.image = image;
        this.link = link;
        this.recolected = recolected;
    }
}

// Función que devuelve las actividades
export default function ActivityData() {
    const data = [
        new Activity(
            Clean4, //IMAGE
            null, // LINK
            64, //KG RECOLECTED
            "Limpieza en Humedales de Toluca", //Title esp
            "Toluca, Edomex", //Location esp
            "20/10/24", // Date esp
            "Gran jornada de recolección en una zona ecológicamente vital. Recolectamos alrededor de 64 kg de residuos que se encontraban entre vegetación y biodiversidad local.",  // Desc esp

            "Cleanup at the Toluca Wetlands", // Title en
            "Toluca, State of Mexico", // Location en
            "10/20/24", // Date en
            "A major cleanup day in an ecologically vital area. We collected around 64 kg of waste found among local vegetation and biodiversity." // Desc en
        ),

        new Activity(
            Clean3, //IMAGE
            null, // LINK
            124.7, //KG RECOLECTED
            "Segunda limpieza en la Laguna del Castillo", //Title esp
            "Laguna del Castillo en Xalapa, Veracruz.", //Location esp
            "08/06/24", // Date esp
            "Volvimos a esta laguna urbana con mejoras operativas y realizamos nuevas pruebas para validar el alcance y desempeño de Sharky.",  // Desc esp

            "Second Cleanup at Laguna del Castillo", // Title en
            "Laguna del Castillo, Xalapa, Veracruz", // Location en
            "06/08/24", // Date en
            "We returned to this urban lagoon with improved operational conditions and ran new tests to validate Sharky’s reach and performance." // Desc en
        ),

        new Activity(
            Clean2, //IMAGE
            null, // LINK
            150.6, //KG RECOLECTED
            "Limpieza en el Río Lerma", //Title esp
            "Río Lerma en Toluca, Edomex", //Location esp
            "21/04/24", // Date esp
            "Limpieza en uno de los ríos más contaminados del país. Una jornada de impacto ambiental y conciencia comunitaria.",  // Desc esp

            "Cleanup at the Lerma River", // Title en
            "Lerma River, Toluca, State of Mexico", // Location en
            "04/21/24", // Date en
            "Cleanup effort at one of the most polluted rivers in the country. A day of environmental impact and community awareness." // Desc en
        ),

        new Activity(
            Clean1, //IMAGE
            null, // LINK
            null, //KG RECOLECTED
            "Primeras pruebas realizadas con Sharky", //Title esp
            "Laguna del Castillo en Xalapa, Veracruz", //Location esp
            "05/02/24", // Date esp
            "Realizamos nuestras primeras pruebas de navegación y recolección con Sharky, comprobando su maniobrabilidad, autonomía y capacidad de carga. Un paso clave para validar nuestra tecnología en campo real.", // Desc esp

            "First Tests with Sharky", // Title en
            "Laguna del Castillo, Xalapa, Veracruz", // Location en
            "02/05/24", // Date en
            "We conducted our first navigation and collection tests with Sharky, verifying its maneuverability, autonomy, and load capacity. A key step in validating our technology in real-field conditions." // Desc en
        )
    ];

    return data;
}